/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, Icon, message, Table, Drawer, Empty } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import AddForm from './addForm'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isAddFormShown: false,
			isEdit: false,
			selectedBarangayTerm: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid } = AuthStore
		const { page, pageSize, sortOrder, sortName, searchText,
			isAddFormShown, isEdit, selectedBarangayTerm
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		
		return (
			<Row type='flex' justify='center'>
				<Col md={24} sm={24}>
					<Row>
						<button type="button" className="btn btn-primary btn-rounded waves-effect waves-light" onClick={() => {
							this.setState({ isAddFormShown: true, isEdit: false, selectedBarangayTerm: null })
						}} style={{ float: 'right' }}>Add New</button>
						<Input placeholder='Search Here' style={{ width: 230, float: 'right', marginRight: 20, marginTop: 5 }} onChange={(e) => {
							this.setState({ searchText: e.target.value })
						}}/>
					</Row>
					<br />
					<Row>
						<Query query={BARANGAY_TERMS} variables={{ searchFilter: filters, barangay_uid }}>
							{({ loading, error, data }) => {
								if (error) return <Empty/>

								let barangayTerms = _.has(data,'barangayTerms') ? data.barangayTerms.data : []
								barangayTerms = barangayTerms.map((barangayTerm, key) => Object.assign({}, barangayTerm, { key }))
								let _pagination = _.has(data, 'barangayTerms') ? data.barangayTerms.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								const columns = [
									// {
									// 	title: 'UID',
									// 	dataIndex: 'uid',
									// 	key: 'uid',
									// 	width: 300
									// }, 
									{
										title: 'Start Date',
										key: 'start_date',
										render: (record) => {
											return (
												<span>{moment(record.start_date).format('LL')}</span>
											)
										}
									}, {
										title: 'End Date',
										key: 'end_date',
										render: (record) => {
											return (
												<span>{moment(record.end_date).format('LL')}</span>
											)
										}
									}, {
										title: 'Duration',
										key: 'duration',
										render: (record) => {
											const duration = moment.duration(moment(record.end_date).diff(moment(record.start_date)))
											return (
												<span>{duration.asDays()} day(s)</span>
											)
										}
									}, {
										title: 'Status',
										key: 'status',
										render: (record) => {
											const status = _.isEqual(record.is_active, 1) ? <span className="badge badge-success">Active</span> : 
												<span className="badge badge-pink">Inactive</span>
											return (
												<span>{status}</span>
											)
										}
									}, {
										title: 'Action',
										key: 'action',
										render: (record) => {
											return (
												<React.Fragment>
													<a href="#" onClick={() => this.setState({ isAddFormShown: true, isEdit: true, selectedBarangayTerm: record })}>Edit</a>
												</React.Fragment>
											)
										}
									}]
								return (
									<Table 
										loading={loading}
										columns={columns} 
										dataSource={barangayTerms} 
										bordered
										onChange={this.handleOnChange}
										pagination={_pagination}
										scroll={{ x: 1020 }}
									/>
								)
							}}
						</Query>
					</Row>
					{
						isAddFormShown &&
                        <AddForm
                        	isEdit={isEdit}
                        	selectedBarangayTerm={selectedBarangayTerm}
                        	visible={isAddFormShown}
                        	onClose={() => this.setState({ isAddFormShown: false, isEdit: false, selectedBarangayTerm: null })}
                        />
					}
				</Col>
			</Row>
		)
	}
}

const BARANGAY_TERMS = gql`
    query barangayTerms($barangay_uid: String, $searchFilter: SearchParams) {
		barangayTerms(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
